import { ReactNode } from "react";
import { GenericLayout, MUIBox } from "@cobee/cobee-ui";
import WrappedSidebarV2 from "v2/ui/components/SidebarV2";
import LayoutHeader from "./components/LayoutHeader";

export default function AppLayout({ children }: { children: ReactNode }) {
  return (
    <GenericLayout
      headerComponent={
        <MUIBox ml={15}>
          <LayoutHeader />
        </MUIBox>
      }
      leftComponent={<WrappedSidebarV2 />}
    >
      <MUIBox ml={15} mt={2} mr={5} mb={2}>
        {children}
      </MUIBox>
    </GenericLayout>
  );
}
